export default {
  readyToJoin: `Prêt à joindre?`,
  join: 'Joindre!',
  waitingForCandidate: `En attente du candidat`,
  alreadyJoinedHeader: "Un recruteur s'est déjà joint à l'entrevue",
  alreadyJoinedBy: "est présentement dans l'entrevue.",
  okay: 'OK',
  ratingDisabledTooltip: "Vous pouvez évaluer ce candidat pour jusqu'à 24 heures suivant l'entrevue.",
  testSpeaker: 'Vérifier sortie audio',
  yourDevices: `Choisir le périphérique que vous allez utiliser pour écouter l'entrevue`,
  done: 'Terminer',
  checkYourDevice: 'Vérifier sortie audio',
  guestMeet: {
    readyToJoin: `Vous êtes quasiment arrivé!`,
    enterInfoToJoin: `Saisissez votre nom, votre adresse e-mail et votre code de vérification pour accéder à l'entrevue. Vous pouvez trouver votre code de vérification dans courriel d'invitation original que vous avez reçu pour accéder à cet entrevue.`,
    name: 'Nom',
    namePlaceholder: 'Entrez votre nom',
    nameRequired: 'Votre nom est requis',
    email: 'Email',
    emailPlaceholder: 'Sélectionnez une adresse courriel',
    customEmailPlaceholder: 'Écrire une adresse courriel',
    emailRequired: 'Une adresse courriel est requise',
    invalidEmail: 'Adresse courriel invalide',
    codeRequired: 'Le code est requis',
    code: 'Code de vérification',
    codePlaceholder: 'Entrez le code de vérification que vous avez reçu',
    join: 'Joindre',
    hintMessageBeforeJoin: `Pour vous préparer à l'entretien, assurez-vous d'utiliser le casque ou l'appareil que vous utiliserez lors de l'événement.`,
    joinAsLabel: `Vous êtes connecté comme l'utilisateur  {{userName}}.`,
    joinMessage: `Vous pouvez maintenant joindre l'entrevue.`,
    joinMessagePreInterview: `Cette entrevue commencera à {{time}}.`,
    joinMessagePreInterviewOnAnotherDay: `Cette entrevue commencera le {{day}} à {{time}}.`,
    joinMessagePastInterview: `Cette entrevue est complétée.`,
    interviewCancelled: 'Le candidat a annulé son entrevue pour le poste de {{position}} chez {{location}} prévue le {{time}}.',
    invalidCode: 'Code invalide',
    leaveCall: `Quitter l'entrevue`,
    sessionModalTitle: 'Avis',
    sessionModalText: `Vous vous êtes connecté avec succès en tant que co-intervieweur.`,
    errorMessage: `Vous n'avez pas pu vous connecter en raison d'une erreur. Veuillez réessayer de vous connecter.`,
    playAudio: "Jouer l'audio",
  },
  errorCode: {
    '1005': `Vous ne pouvez pas joindre l'entrevue avant qu'elle commence.`,
    '1006': `Vous ne pouvez pas joindre l'entrevue après qu'elle soit terminée.`,
  },
  collaboratorFeatureNotAvailable: `Notre fonctionnalité de co-intervieweur est actuellement non disponible.`,
  timeEndingAlert: {
    giveAssessment: "N'oubliez pas d'évaluer ce candidat!",
    interviewTimeEnd: 'Cette entrevue termine bientôt.',
    timeRemaining: "Cette entrevue termine bientôt, donc assurez-vous d'évaluer le candidat si ce n'est pas déjà fait.",
    interviewEndAfter: 'Cette entrevue termine automatiquement dans',
    okay: `J'ai compris`,
  },
  candidateInformation: 'Renseignements du candidat',
  others: 'Autre',
};
